<template>
  <div class="attachment-div">
    <div :class="getAttachmentImgDiv">
      <img
        :src="attachment"
        class="mx-auto d-block attachment-img align-middle"
        @click.prevent="openImage"
      />
    </div>
    <div class="mt-2 attachment-discard-div" >
      <a
        v-if="discardVisible"
        href="#"
        @click="discard($event)"
      >
        <label class="link">
          {{ $t("geral.discard") }}
        </label>
      </a>
    </div>
    <fullscreen-sidebar ref="fullscreenSidebar">
      <template v-slot:content>
        <div class="fullscreen-container">
          <img
            class="fullscreen-sidebar-img align-middle d-block mx-auto"
            :src="attachment"
          />
        </div>
      </template>
    </fullscreen-sidebar>
    <div class="textAttachment" v-if="attachmentNumber != null">
      Anexo {{ attachmentNumber }}
    </div>
  </div>
</template>

<script>
import FullscreenSidebar from "@/components_rms/FullscreenSidebar.vue";

export default {
  components: {
    FullscreenSidebar,
  },
  props: {
    attachment: String,
    discardVisible: Boolean,
    attachmentNumber: Number,
  },
  data: function () {
    return {};
  },
  created: function () {},
  computed: {
    getAttachmentImgDiv() {
      if (this.discardVisible) return "attachment-img-div";
      return "attachment-img-div mb-4";
    },
  },
  methods: {
    discard(e) {
      e.preventDefault();
      this.$emit("discard", this.attachment);
    },
    openImage() {
      this.$refs.fullscreenSidebar.open();
    },
  },
};
</script>

<style scoped>
.attachment-div {
  border: 1px;
  border-color: #2b3553;
  border-radius: 0.4285rem;
  border-style: solid;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 20px;
  margin-top: 10px;
  margin-bottom: 15px;
}
.attachment-discard-div {
  text-align: center;
  
}
.attachment-img {
  max-width: 100%;
  max-height: 100%;
  cursor: -webkit-zoom-in;
  cursor: zoom-in;
}
.attachment-img-div {
  align-items: center !important;
  display: flex;
  max-width: 100%;
  max-height: 100%;
  height: 150px;
}
.textAttachment {
  text-align: center;
}
.link{
  cursor: pointer
}
.link:hover {
  color: white !important;  
}
</style>
